import axios, { AxiosResponse } from 'axios';

export interface IUserApi {
  getAccount(): Promise<AxiosResponse<any>>;
  getLogout(): Promise<AxiosResponse<any>>;
}

export class UserApi implements IUserApi {
  async getAccount(): Promise<AxiosResponse<any>> {
    const user = axios.get('api/user/account');
    return user;
  }

  async getLogout(): Promise<AxiosResponse<any>> {
    return axios.post('api/logout');
  }

  async findSellingPoint(): Promise<AxiosResponse<any>> {
    return axios.post('api/sellingPoint/findDetail');
  }

  async getSubscriber(clientNumber): Promise<AxiosResponse<any>> {
    return axios.get('api/user/getSubscriber' + clientNumber);
  }
}
